/**
 * Aviso de dev-time para uso indevido de um componente contra uma regra de marca
 * (ex.: Lime fora de estado de prova, variante Blue-fill em texto pequeno, selo sem
 * rótulo). Nunca lança — o produto não pode quebrar por causa de um aviso de marca;
 * o objetivo é aparecer no console de quem está integrando, não travar produção.
 * Silencioso quando `process.env.NODE_ENV === 'production'` (Vite substitui essa
 * expressão em build, ver AMVP-01/apps Vite deste monorepo).
 */
export function devWarn(message: string): void {
  const isProd =
    typeof process !== 'undefined' &&
    typeof process.env !== 'undefined' &&
    process.env.NODE_ENV === 'production';
  if (isProd) return;
  // eslint-disable-next-line no-console
  console.warn(`[@argink/ui] ${message}`);
}
